import React from 'react';
import {auth} from '../../firebase/firebase.utils'
import {Link} from 'react-router-dom'
const Navigation = ({ user,setNull }) => {
    const signOut = () => {
      auth.signOut()
    }
    if (user!==null) {
      return (
        <nav style={{display: 'flex', justifyContent: 'flex-end'}}>
          <Link to="/" className="f3 link dim  white pa3 pointer">Home</Link>
          <p onClick={() => {signOut();setNull()}} className='f3 link dim white pa3 pointer'>Sign Out</p>
        </nav>
      );
    } else {
      return (
        <nav style={{display: 'flex', justifyContent: 'flex-end'}}>
         <Link to="/"> <p className='f3 link dim  white pa3 pointer'>Sign In</p></Link>
         <Link to="/signup"><p className='f3 link dim white   pa3 pointer'>Register</p></Link>
         <Link to="/admin"><p  className='f3 link dim  white pa3 pointer'>Admin</p></Link>
        </nav>
      );
    }
}

export default Navigation;